module.exports = __webpack_public_path__ + "img/select.ca279240.svg";